import { mapGetters } from 'vuex';
import { ROLES } from '@/constants/roles';

export default {
  computed: {
    ...mapGetters(['me', 'isProfileLoaded']),
  },

  methods: {
    getName(user) {
      return `${user.firstName} ${user.lastName}`;
    },
    getId(user) {
      return user.id;
    },
    hasRole(role) {
      return this.me && this.me.role === role;
    },
    isAdministrator() {
      return this.hasRole(ROLES.ADMINISTRATOR);
    },
    isChiefLoanOfficer() {
      return this.hasRole(ROLES.CHIEF_LOAN_OFFICER);
    },
    isLoanOfficer() {
      return this.hasRole(ROLES.LOAN_OFFICER);
    },
    isAccountant() {
      return this.hasRole(ROLES.ACCOUNTANT);
    },
    isOperator() {
      return this.hasRole(ROLES.OPERATOR);
    },
    isCollectionsOfficer() {
      return this.hasRole(ROLES.COLLECTIONS_OFFICER);
    },
    isStatistics() {
      return this.hasRole(ROLES.STATISTICS);
    },
    isViewer() {
      return this.hasRole(ROLES.VIEWER);
    },
  },
};
